module.exports = __webpack_public_path__ + "img/logo-mimoto.c03b0fdb.png";